import {Fragment} from 'react';
import type {ReactNode} from 'react';
import {useAppI18n} from '../../lib/appI18n';
import {translate,pattern,dateLabel,relativeLabel} from './providerMessages.mjs';
import {diagnosis as originalDiagnosis} from './diagnosis.mjs';
// Feature vocabulary only. Locale state and controls belong to AppI18nProvider.
export function useProviderText(){
 const {locale,formatNumber}=useAppI18n();
 const pt=(value:any):any=>typeof value==='string'?(/^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d/.test(value)?dateLabel(value,locale):translate(value,locale)):typeof value==='number'?formatNumber(value):value;
 const pr=(key:string,values:ReactNode[]=[]):ReactNode=>{
  const text=pattern(key,locale),parts=text.split(/(\{\d+\})/g);
  return parts.map((part,index)=>{
   const match=/^\{(\d+)\}$/.exec(part);
   return match?<Fragment key={'slot-'+match[1]}>{pt(values[Number(match[1])])}</Fragment>:<Fragment key={'text-'+index}>{part}</Fragment>;
  });
 };
 const time=(value:any)=>dateLabel(value,locale);
 const relativeTime=(value:any,now=Date.now())=>relativeLabel(value,locale,now);
 const latencyView=(ms:any)=>typeof ms!=='number'||!Number.isFinite(ms)||ms<0?
  {label:translate('Süre ölçümü yok',locale),tone:'off',width:0}:
  {label:formatNumber(Math.round(ms))+' ms',tone:ms<1000?'connected':ms<=3000?'ready':'error',width:Math.min(100,Math.max(3,ms/100))};
 const diagnosis=(row:any)=>{const value=originalDiagnosis(row);return value?{...value,title:pt(value.title),cause:pt(value.cause),impact:pt(value.impact),action:pt(value.action)}:null;};
 const durationLabel=(row:any)=>{
  const ms=row?.duration_ms;if(typeof ms!=='number'||!Number.isFinite(ms)||ms<0)return pt('Bu aşamada süre ölçümü yok');
  const text=formatNumber(Math.round(ms))+' ms',d=row.detail||{},issue=originalDiagnosis(row);
  const key=d.operator_test&&d.phase==='FINISHED'?'Toplam test işlemi: {0} (model yanıt hızı değil)':
   d.phase==='BLOCKED'||d.phase==='ERROR'?'Ön kontrol / işlem süresi: {0}':
   issue&&issue.kind!=='latency'?'Hata / ret yanıtı: {0} (başarılı yanıt hızı değil)':'İstek süresi: {0}';
  return pattern(key,locale).replace('{0}',text);
 };
 return {pt,pr,locale,time,relativeTime,latencyView,diagnosis,durationLabel};
}
